import moment from 'moment'

export const getDefaultAuthorData = () => {
  return {
    lastName: '',
    firstName: '',
    firstNameInitial: '',
    extraName: '',
    extraNameInitial: ''
  }
} 
export const getDefaultSourceData = () => {
  return {
    type: 'article',
    authors: [],
    pages: '',
    source: '',
    title: '',
    year: '',
    url: '',
    accessMode: 'free',
    accessDate: moment().format('YYYY-MM-DD')
  }
}


// WEBPACK FOOTER //
// ./src/shared/defaults.js